// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-preview_wrapper__BDMR- {
  pointer-events: none;

  position: absolute;
  z-index: 10;
  bottom: 100%;
  transform-origin: center bottom;
  transform: translateY(10px) scale(0.9);

  overflow: hidden;

  border-radius: 3px;

  line-height: 23px;
  color: var(--textColor);
  text-align: center;
  letter-spacing: 0px;

  opacity: 0;
  background: var(--backgroundColor);
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);

  transition-duration: 0.15s;
  transition-property: opacity, transform;
}

.timeline-preview_wrapper__BDMR-.timeline-preview_active__vXlU6 {
    transform: translateY(0) scale(1);
    opacity: 1;
  }

.timeline-preview_wrapper__BDMR- .timeline-preview_thumbnailWrapper__rRZvG {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(217, 217, 217, 1);
  }

.timeline-preview_wrapper__BDMR- .timeline-preview_content__5hugz {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;

    padding: 8px;
  }

.timeline-preview_wrapper__BDMR- .timeline-preview_chapterTitle__a9zqd {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    font-size: 12px;
    font-weight: 700;
    line-height: 14.63px;
    color: var(--textColor);
    text-align: center;
  }

.timeline-preview_wrapper__BDMR- .timeline-preview_hoveredTime__drsa\\+ {
    padding: 2px 10px 2px 10px;
    border-width: 0;
    border-radius: 3px;

    font-size: 12px;
    font-weight: 700;
    color: #ffffff;

    background: rgba(0, 0, 0, 0.5);
  }

@media (prefers-reduced-motion) {
  .timeline-preview_wrapper__BDMR- {
    transform: none;
    transition: none;
  }
}

.timeline-preview_wrapper__BDMR- div {
  background-repeat: no-repeat;
}
`, "",{"version":3,"sources":["webpack://./src/components/timeline-preview/timeline-preview.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;;EAEtC,gBAAgB;;EAEhB,kBAAkB;;EAElB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;;EAEnB,UAAU;EACV,kCAAkC;EAClC,+CAA+C;;EAE/C,0BAA0B;EAC1B,uCAAuC;AAiDzC;;AA/CE;IACE,iCAAiC;IACjC,UAAU;EACZ;;AAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,wCAAwC;EAC1C;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;;IAEnB,YAAY;EACd;;AAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;;IAErB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;EACpB;;AAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;IAChB,cAAc;;IAEd,8BAA8B;EAChC;;AAGF;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".wrapper {\n  pointer-events: none;\n\n  position: absolute;\n  z-index: 10;\n  bottom: 100%;\n  transform-origin: center bottom;\n  transform: translateY(10px) scale(0.9);\n\n  overflow: hidden;\n\n  border-radius: 3px;\n\n  line-height: 23px;\n  color: var(--textColor);\n  text-align: center;\n  letter-spacing: 0px;\n\n  opacity: 0;\n  background: var(--backgroundColor);\n  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.25);\n\n  transition-duration: 0.15s;\n  transition-property: opacity, transform;\n\n  &.active {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n\n  & .thumbnailWrapper {\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    background-color: rgba(217, 217, 217, 1);\n  }\n\n  & .content {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: center;\n\n    padding: 8px;\n  }\n\n  & .chapterTitle {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 14.63px;\n    color: var(--textColor);\n    text-align: center;\n  }\n\n  & .hoveredTime {\n    padding: 2px 10px 2px 10px;\n    border-width: 0;\n    border-radius: 3px;\n\n    font-size: 12px;\n    font-weight: 700;\n    color: #ffffff;\n\n    background: rgba(0, 0, 0, 0.5);\n  }\n}\n\n@media (prefers-reduced-motion) {\n  .wrapper {\n    transform: none;\n    transition: none;\n  }\n}\n\n.wrapper div {\n  background-repeat: no-repeat;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `timeline-preview_wrapper__BDMR-`,
	"active": `timeline-preview_active__vXlU6`,
	"thumbnailWrapper": `timeline-preview_thumbnailWrapper__rRZvG`,
	"content": `timeline-preview_content__5hugz`,
	"chapterTitle": `timeline-preview_chapterTitle__a9zqd`,
	"hoveredTime": `timeline-preview_hoveredTime__drsa+`
};
export default ___CSS_LOADER_EXPORT___;
